import { SystemField } from "./system-field";

export class PurchasePayment extends SystemField {
    
    received_by_id?:string;
    amount?:number;
    payment_num?:string;
    pay_by_id?:string;
    payment_date?:string;
    payment_type?:string;
    vendor_id?:string;
    status?:string;
    payment_method?:string;
    cash_acc_id?:string
}
export class PurchasePaymentTranslation extends SystemField{
     
     purchase_payment_id?:string;
     description?:string;
     lang_code?:string;
}